module.exports = __webpack_public_path__ + "static/img/img30.ccc96fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img30.png
// module id = MTh8
// module chunks = 1